// views/Dashboard/PainelExecutivo/sections/comercial/planilhaNegociacoes.ts
import type { Planilha } from '../../../../Financeiro/PainelExecutivo/lib/planilhasPainel.ts';
import { dataParaSerialExcel } from '../../../../Financeiro/PainelExecutivo/lib/planilhasPainel.ts';
import type { LinhaNegociacao } from '../../../../../src/lib/dashboard/negociacoesDaEtapa.ts';
import { ROTULOS_CANAL, rotuloMes } from '../../../../../src/lib/dashboard/negociacoesDaEtapa.ts';
import { STATUS_LABELS } from '../../../../../src/lib/crmVisuals.ts';

/**
 * A lista de uma etapa do funil como aba de Excel. Dados puros: quem gera o
 * arquivo é `baixarPlanilhas`, igual ao Financeiro.
 *
 * "Sem responsável" sai escrito assim, e não em branco: é o que explica uma
 * negociação grande aparecer em Venda Externa sem ninguém por trás.
 */
export function planilhaNegociacoes(linhas: LinhaNegociacao[], nome = 'Negociações'): Planilha {
  const base = planilhaBase(linhas, nome);
  // #6331: a lista de "Termo Reprovado" leva o motivo e se a data é aproximada.
  if (!linhas.some((l) => l.motivoReprovacao)) return base;
  return {
    ...base,
    headers: [...base.headers, 'Motivo da reprovação', 'Data aproximada'],
    rows: base.rows.map((r, i) => [...r, linhas[i].motivoReprovacao || '', linhas[i].dataAproximada ? 'Sim' : '']),
    colTypes: [...base.colTypes, 'txt', 'txt'],
    widths: [...(base.widths || []), 26, 16],
    totals: base.totals ? [...base.totals, '', ''] : base.totals,
  };
}

function planilhaBase(linhas: LinhaNegociacao[], nome: string): Planilha {
  const headers = ['Cliente', 'CPF/CNPJ', 'Cidade', 'Tipo', 'Origem', 'Responsável', 'Canal', 'Data da etapa', 'Consumo (kWh)', 'Status atual', 'Etapas puladas', 'Etapa anterior', 'Atravessou o mês'];
  return {
    nome,
    headers,
    rows: linhas.map((l) => [
      l.cliente,
      l.cpfCnpj || '',
      l.cidade || '',
      l.tipoCliente || '',
      l.origem || '',
      l.responsavel || 'Sem responsável',
      ROTULOS_CANAL[l.canal],
      dataParaSerialExcel(l.data),
      l.kwh,
      STATUS_LABELS[l.status] || l.status || '',
      l.etapasPuladas.join(', '),
      l.etapaAnterior ? `${l.etapaAnterior.label} em ${rotuloMes(l.etapaAnterior.data)}` : '',
      l.atravessouMes ? 'Sim' : '',
    ]),
    colTypes: ['txt', 'txt', 'txt', 'txt', 'txt', 'txt', 'txt', 'data', 'kwh', 'txt', 'txt', 'txt', 'txt'],
    widths: [38, 20, 20, 12, 18, 24, 18, 14, 16, 20, 32, 26, 16],
    totals: [
      `Total: ${linhas.length.toLocaleString('pt-BR')} negociações`,
      '', '', '', '', '', '', '',
      linhas.reduce((s, l) => s + l.kwh, 0),
      '', '', '',
      `${linhas.filter((l) => l.atravessouMes).length} de outro mês`,
    ],
  };
}
